import { z } from 'zod'

const ZPlayfileContent = z.object({
  playfile: z.string(),
})

export default ZPlayfileContent
